
import AppData from './AppData';

// class DeliveryDetail {
//     static initWithJson(json) {

//     }
//     constructor(json) {
//         this.lat = null
//         this.lng = null
//         this.streetNumber = null
//         this.addressComponents = []
//         this.duration = null
//         this.distance = null
//         this.deliveryCharge = null
//     }
// }


function DeliveryDetail() {
    this.id = null
    this.lat = null
    this.lng = null
    this.streetNumber = null
    this.addressComponents = []
    this.duration = null
    this.distance = null
    this.deliveryCharge = null
    this.deliveryDatetime = null
    this.baseCharge = 0
    this.merchantCoverFee = 0
    this.processingFee = 0
    this.is_no_delivery_time = false

    this.toSnakeJson = this.toSnakeJson.bind(this)
}

/**
 * @param {Object} json 
 * @return DeliveryDetail
 */
export function DeliveryDetail_fromJson(json) {
    json = {...json}
    let castToFloat = ["base_charge", "delivery_charge", "processing_fee", "merchant_cover_fee"]
    castToFloat.forEach(key => [
        json[key] = parseFloat(json[key])
    ])
    let a = new DeliveryDetail()

    Object.keys(a).forEach(key => {
        if (typeof a[key] === 'function') {
            // We only copy value, don't change function
            return
        }
        a[key] = json[camelToSnake(key)]
    })
    return a
}

/**
 * Convert all object key to snake case
 */
DeliveryDetail.prototype.toSnakeJson = function() {
    let a = {}
    Object.keys(this).forEach(key => {
        a[camelToSnake(key)] = this[key]
    })
    return a
}

function snakeToCamel(string) {
    return string.replace(/(_\w)/g, function(m){
        return m[1].toUpperCase();
    });
}
function camelToSnake(string) {
    return string.replace(/[\w]([A-Z])/g, function(m) {
        return m[0] + "_" + m[1];
    }).toLowerCase();
}

export default DeliveryDetail;